{
  "id": 40,
  "location": "paris",
  "difficulty": "hard",
  "moves": 23,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "cookie", "count": 44 }
  ],
  "stars": [5090, 6390],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . x x x x . .",
    ". . x . . x . .",
    ". . x . . x . .",
    ". . x x x x . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.461, "movesLeft": 3.9, "closeLosses": 0.102, "target": 0.42 }
}
